import { render, staticRenderFns } from "./growers_settlement.vue?vue&type=template&id=7910cd0a"
import script from "./growers_settlement.vue?vue&type=script&lang=js"
export * from "./growers_settlement.vue?vue&type=script&lang=js"
import style0 from "./growers_settlement.vue?vue&type=style&index=0&id=7910cd0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports